import { IconButton, Tooltip, Typography } from "@mui/material";
import Card from "@mui/material/Card";
import Stack from "@mui/material/Stack";
import EmailEditor from "react-email-editor";
import { Block } from "src/components/Block";
import Iconify from "src/components/iconify/iconify";

const EmailBuilderComm = ({ editorShortRef, customMessageData }: any) => {
  const NOTES = [
    {
      label: "describe brotherhood based on gender",
      value: "subject",
    },
    {
      label: "add the user name",
      value: "first_name",
    },
    {
      label: "add the sending date",
      value: "date_now",
    },
  ];

  const helperText = (
    <Stack component="span">
      {NOTES?.map((note, index) => (
        <Typography textAlign="center" sx={{ mb: 1, wordSpacing: 2 }}>
          {index + 1}- If you want to {note.label}, please write
          <Typography style={{ display: "inline" }}>
            {` {{${note.value}}} `}
          </Typography>{" "}
          wherever you want to add it
        </Typography>
      ))}
    </Stack>
  );
  // #endregion States

  const EMAILS = {
    emailType: "emailMessage",
    emailLabel: "Email Message",
    emailMessage: "emailMessageShort",
    emailDesign: "emailDesignShort",
    ref: editorShortRef,
  };
  // #endregion Handlers

  return (
    <>
      <Block label={EMAILS.emailLabel}>
        <Stack direction="row" justifyContent="flex-end">
          <Tooltip
            title={helperText}
            arrow
            PopperProps={{ sx: { color: "red" } }}
          >
            <IconButton color="primary">
              <Iconify icon="zondicons:exclamation-outline" width={24} />
            </IconButton>
          </Tooltip>
        </Stack>
        <Card>
          <EmailEditor
            ref={EMAILS.ref}
            onReady={() =>
              customMessageData?.emailDesignShort &&
              EMAILS.ref!?.current!?.editor!?.loadDesign(
                customMessageData?.emailDesignShort
              )
            }
          />
        </Card>
      </Block>
    </>
  );
};

export default EmailBuilderComm;
